import axios from 'axios';
import Api from '../library/Api.js';
import base from './ServicoBase.js';

export default {

        getModel(tipo) {


                var form = {
                        id: null,
                        tipo: null,
                        id_cliente: null,
                        id_estabelecimento: null,
                        data_cadastro: null,
                        data: null,
                        data_entrada: null,
                        data_saida: null,

                        entrada: "",
                        saida: "",

                        nutricionista_responsavel: "",
                        responsavel_estabelecimento: "",
                        emails_lista: "",
                        id_resp_controllare: null,

                        textos: this.getTextosBase(tipo),
                        arquivos: [],
                        status: 0,
                }

                return form;
        },

        getTextosBase(tipo) {

                if (tipo == null) {
                        tipo = 1;
                }

                var arr = [];

                if (tipo == 1) {

                        arr = [{ codigo: 1, titulo: "Estrutura Física", texto: "" },
                        { codigo: 2, titulo: "Procedimentos de Higiene e Manipulação", texto: "" },
                        { codigo: 3, titulo: "Documentação / Planilhas / POP'S", texto: "" },
                        { codigo: 4, titulo: "Observações Gerais", texto: "" }];

                        return arr;
                }


                arr = [{
                        codigo: 1, titulo: "Medidas adotadas", texto: ""
                }];

                return arr;


        },

        getModelVisualizar() {

                return {
                        id: null,
                        data: null,
                        data_entrada: null,
                        data_saida: null,
                        responsavel_local: "",
                        data_cadastro: null,
                        nutricionista_responsavel: "",
                        responsavel_estabelecimento: "",
                        tipo: "",
                        nome_cliente: "",
                        nome_estabelecimento: "",
                        nome_responsavel: "",
                        cliente_oculto: 0,
                        nota_final: 0,
                        nome_checklist: ""
                }
        },
        getTitulo(tipo) {

                if (tipo != null && tipo != undefined && tipo.toString() == "2") {
                        return "Laudos";

                }

                return "Diagnóstico e plano de ação";

        },

        getById(id) {
                //relatorio_show  relatorio relatorio_show
                return Api.Call("relatorio_show/" + id + "", "get", {});

        },

        getListCliente(data, order, order_type) {

                data["order"] = order;
                data["order_type"] = order_type;
                data["ret"] = "cliente";

                return Api.Call("relatorio?" + base.serialize(data), "get", data);


        },

        getViewCompleta(id, order, order_type) {
                // return Api.Call("inspecao_show/"+ id + "", "get", {});
                return Api.Call("relatorio_show/" + id + "", "get", {});

        },

        salvar(form, fn_progress) {


                if (form.id != null && form.id != "") {
                        // var data = base.removeColumns( form, "cadastrado_por,valido,verificado,eliminado");
                        return Api.Call("relatorio/" + form.id + "", "PUT", form, fn_progress);
                } else {


                        return Api.Call("relatorio", "POST", form, fn_progress);


                }

        },
        delete(id) {
                return Api.Call("relatorio/" + id + "", "DELETE", {});
        },
        filtrar(page, search) {

                var data = { filtro: search, page: page, pagesize: process.env.VUE_APP_PAGESIZE }

                return Api.Call("relatorio_grid", "get", data);


        },

        getList(data, order, order_type) {


                data["order"] = order;
                data["order_type"] = order_type;
                data["ret"] = "cliente";

                return Api.Call("relatorio?" + base.serialize(data), "get", data);


        },

        getListByParent(tabela, id_pai) {


                var data = { tabela: tabela, id_pai: id_pai }

                return Api.Call("relatorio_gridcad?" + base.serialize(data), "get", data);


        },

        salvarGrid(hd_json, ids_delete_json, tabela, id_pai) {

                var data = {
                        hd_json: hd_json,
                        ids_delete_json: ids_delete_json,
                        tabela: tabela,
                        id_pai: id_pai
                };

                return Api.CallFormData("relatorio_salvargrid", "POST", data);

        }


}
